import React, { FC, PropsWithChildren, useContext, useMemo } from 'react'
import { DialogId } from '@feedyou/schema'
import _ from 'lodash'

import { slugify } from '../lib/transliterate'
import { toLowerCase } from '../lib/string'

type MemoizedUtils = {
  // DO NOT USE THIS FOR ANYTHING ELSE THAN DIALOG IDS THAT ACTUALLY EXIST IN CURRENT BOT,
  // OR YOU MAY LEAK ALL MEMORY!! Ideally don't use it at all, unless you know what you're doing.
  slugifyDialogIdMemoized__DANGER: (id: DialogId) => string
  // DO NOT USE THIS FOR ANYTHING ELSE THAN DIALOG IDS THAT ACTUALLY EXIST IN CURRENT BOT,
  // OR YOU MAY LEAK ALL MEMORY!! Ideally don't use it at all, unless you know what you're doing.
  getLowercaseDialogIdMemoized__DANGER: (id: string) => string
  // DO NOT USE THIS FOR ANYTHING ELSE THAN DIALOG NAMES THAT ACTUALLY EXIST IN CURRENT BOT,
  // OR YOU MAY LEAK ALL MEMORY!! Ideally don't use it at all, unless you know what you're doing.
  getLowercaseDialogNameMemoized__DANGER: (name: string) => string
}

export const MemoizedUtilsContext = React.createContext<MemoizedUtils>(null as any)

export const MemoizedUtilsProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  // The main difference between this and a memoized reselect selector is that this function does not
  // recompute all of the ids on every change in any of the dialogs.
  //
  // The downside is that this function never drops any cached slugified ids - but we don't
  // care too much, since the cache keys (existing dialog ids) rarely change.
  const slugifyDialogIdMemoized__DANGER = useMemo(() => _.memoize(slugify), [])
  const getLowercaseDialogIdMemoized__DANGER = useMemo(() => _.memoize(toLowerCase), [])
  const getLowercaseDialogNameMemoized__DANGER = useMemo(() => _.memoize(toLowerCase), [])

  return (
    <MemoizedUtilsContext.Provider
      value={{
        slugifyDialogIdMemoized__DANGER,
        getLowercaseDialogIdMemoized__DANGER,
        getLowercaseDialogNameMemoized__DANGER
      }}
    >
      {children}
    </MemoizedUtilsContext.Provider>
  )
}

export const useMemoizedUtils = () => {
  const utils = useContext(MemoizedUtilsContext)

  if (!utils) {
    throw new Error('useMemoizedUtils used outside of provider')
  }

  return utils
}
